import { portalApi } from '../../store/generated/portal/userContext';
import userContextSlice from '../slices/userContextSlice';

export const UserContextApiTags = {
  UserContext: 'UserContext',
  OrganizationContext: 'OrganizationContext',
} as const;

export const userContextApi = portalApi.enhanceEndpoints({
  addTagTypes: [UserContextApiTags.UserContext],
  endpoints: {
    apiPortalV1ContextRetrieve: {
      providesTags: [UserContextApiTags.UserContext],
      keepUnusedDataFor: Infinity, // Never purge from cache
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(userContextSlice.actions.updateOrganizations(data.organizations));
        } catch (err) {
          console.error('[USER CONTEXT QUERY] Error:', err);
        }
      },
    },
  },
});

